export default "__VITE_ASSET__03d897b8__"